import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const AppContainer = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "app-container" */ './app-container')),
});
